import reportsConfig from '~/constants/data-reports/recycling'

const blackMassData = {
  hero: reportsConfig.hero,
  descriptions: [
    'After pre-treatment such as crushing pyrolysis and sorting, end-of-life lithium-ion batteries or factory waste (packaging, electrolyte, electrode plates, etc.) that does not meet the factory standards for batteries, are shredded and crushed.',
    'Once processed these become a become black powder, known as black mass.',
  ],
  descriptionImage:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto/v1719531944/assets/Long_yellow_conveyor_b1rqwc.png',
  methodologyInfo: {
    category: 'methodology-price-assessments',
    file_name: 'Benchmark-Black-Mass-Price-Assessment-Methodology.pdf',
  },
  services: [
    {
      icon: 'services/icon-chart-line',
      description:
        'Create your own custom pricing charts using our bespoke data.',
    },
    {
      icon: 'services/icon-presentation',
      description:
        'Produce custom made representations of data to download for projects and presentations.',
    },
    {
      icon: 'services/icon-consultancy',
      description:
        'Access Benchmark’s exclusive industry commentary collected through our extensive network of industry contacts.',
    },
    {
      icon: 'services/icon-idea',
      description:
        'Our goal is to help you understand the context of our data, not just give you the numbers.',
    },
  ],
  indexTab: true,
  requiredFilters: ['feedstocks', 'products', 'shippingRoutes', 'priceTypes'],
  brochureFile: {
    file_name: 'Benchmark-Recycling-Price-Assessment-Methodology.pdf',
    category: 'methodology-price-assessments',
    EnvKey: 'blackMassPriceAssessmentsMethodologyId',
  },
}
export default blackMassData
